$(function() {
    $('table.container').on("click", "tr.table-tr", function() {
        window.location = $(this).data("url");
        //alert($(this).data("url"));
    });
});
